import { useState, useEffect, useMemo } from 'react';
import { __ } from '@wordpress/i18n';
import CptTable from './CptTable';
import { activityColumns, isActivityPast } from './CptTable/columns/activities';
import {
	fetchAllActivities,
	fetchMyRegistrations,
	withUserRegistrations,
} from '../scripts/activitiesData';

/**
 * "My activities" section of the profile page: the activities the current user
 * has registered to (any status, past ones included), newest first.
 */
export default function MyActivitiesTable() {
	const [ data, setData ] = useState( [] );
	const [ loading, setLoading ] = useState( true );
	const [ error, setError ] = useState( null );

	useEffect( () => {
		Promise.all( [ fetchAllActivities(), fetchMyRegistrations() ] )
			.then( ( [ nodes, registrations ] ) => {
				const mine = nodes.filter(
					( node ) => registrations[ node.databaseId ]
				);
				setData(
					withUserRegistrations( mine, registrations, setData )
				);
			} )
			.catch( ( err ) => setError( err.message ) )
			.finally( () => setLoading( false ) );
	}, [] );

	const columns = useMemo( () => activityColumns( { mine: true } ), [] );

	if ( error ) {
		return (
			<div className="px-4 py-3 border-2 border-red text-red text-sm">
				{ __( 'Error loading data:', 'anacrm' ) } { error }
			</div>
		);
	}

	if ( ! loading && data.length === 0 ) {
		return (
			<p>
				{ __( 'You have not registered to any activity yet.', 'anacrm' ) }
			</p>
		);
	}

	return (
		<CptTable
			columns={ columns }
			data={ data }
			isLoading={ loading }
			searchPlaceholder={ __( 'Search activities…', 'anacrm' ) }
			initialSorting={ [ { id: 'dateStart', desc: true } ] }
			getRowClassName={ ( row ) =>
				isActivityPast( row ) ? 'opacity-60' : ''
			}
			fitWidth
		/>
	);
}
